import { render, staticRenderFns } from "./warehouse.vue?vue&type=template&id=4eb24747&scoped=true&"
import script from "./warehouse.vue?vue&type=script&lang=ts&"
export * from "./warehouse.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb24747",
  null
  
)

export default component.exports